module.exports = __webpack_public_path__ + "img/1_3.f6f01dd9.png";